import { useState } from "react"
import { Box, Tab, Typography } from "@mui/material"
import Colors from "assets/colors"
import { BsArrowLeft, BsFilm, BsInfoCircle, BsThreeDots } from "react-icons/bs"
import { TabContext, TabList, TabPanel } from "@mui/lab"
import Detail from "./Detail"
import Media from "./Media"
import useSWR from "swr"
import { useNavigate, useParams } from "react-router-dom"
import StatusBanner from "components/StatusBanner"
import Statistics from "../components/Statistics"
import { useSelector } from "react-redux"

export const MovieDetails = () => {
  const { movieId } = useParams()
  const navigate = useNavigate()
  const tvSeriesData = useSelector((state:any) => state.moviebox.formData)

  const { data: movieData } = useSWR(movieId ? `/entertainment/movie-box/medias/${movieId}` : null)
  const movie = movieId ? movieData?.data : tvSeriesData

  const [value, setValue] = useState('1');

  const handleChange = (event: any, newValue: any) => {
    setValue(newValue);
  };


  // layoutContext.setLayoutStyle('!pl-20 !pt-16 ')
  return (
    <div>
      <div className='w-full bg-white rounded-md p-3'>
        <Typography className="font-semibold flex gap-3 items-center cursor-pointer mb-5" color={Colors.primary} onClick={() => navigate(-1)}>
          <BsArrowLeft strokeWidth={1.5} /> Back
        </Typography>
        {movieId ? <StatusBanner status={movie?.status?.toLowerCase()} /> : <StatusBanner status="pending" />}

      </div>

      <div className="my-5 rounded-md bg-white p-3">

        <div className="flex items-center justify-between">
          <div className="flex flex-col gap-3">
            <Typography>
              {movie?.title || "New TV Series"}
            </Typography>
            <Typography className="text-lg text-dark-blue font-semibold">
              {movieId 
                ? `Everything you need to know about ${movie?.title}` 
                : `${movie?.title || "TV Series"} - ${movie?.description || "New series being added"}`
              }
            </Typography>
          </div>

         <div className="flex gap-4">
         {(!movieId || !movie?.seasons?.length) && <button
         onClick={() => navigate(`/movie-box/add-movie?media_type=series`)}
         className="bg-primary text-white rounded-md px-4 py-2 flex items-center gap-2">
            <span className="text-xl">+</span>
            Add Season
          </button>}
           <div className="border rounded-md w-12 h-12 flex items-center justify-center">
            <BsThreeDots size={30} />
          </div>
         </div>
        </div>
      </div>

      <Statistics />

      <Box sx={{ width: '100%', typography: 'body1', }} className="bg-white rounded-md">
        <TabContext value={value}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }} className="mx-4">
            <TabList onChange={handleChange} aria-label="lab API tabs example">
              <Tab label="Media" value="1" icon={<BsFilm />} iconPosition='start' />
              <Tab label="Details" value="2" icon={<BsInfoCircle />} iconPosition='start' />

            </TabList>
          </Box>
          <TabPanel value="1">
            {
              // ["live", "pending", 'rejected'].includes(movie?.status) && 
              <Media status={tvSeriesData ? 'live' : movie?.status || 'pending'} movie={movie} />}
          </TabPanel>
          <TabPanel value="2">
            <Detail movie={movie} />
          </TabPanel>

        </TabContext>
      </Box>


    </div>
  )
}
